import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined'
import ArrowDropDownCircleOutlined from '@mui/icons-material/ArrowDropDownCircleOutlined'
import AttachMoneyOutlined from '@mui/icons-material/AttachMoneyOutlined'
import BarChart from '@mui/icons-material/BarChart'
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined'
import CheckBoxOutlineBlankOutlined from '@mui/icons-material/CheckBoxOutlineBlankOutlined'
import CheckBoxOutlined from '@mui/icons-material/CheckBoxOutlined'
import CorporateFareOutlined from '@mui/icons-material/CorporateFareOutlined'
import CreditCardOutlined from '@mui/icons-material/CreditCardOutlined'
import EventOutlined from '@mui/icons-material/EventOutlined'
import ExpandCircleDownOutlined from '@mui/icons-material/ExpandCircleDownOutlined'
import LocalPhoneOutlined from '@mui/icons-material/LocalPhoneOutlined'
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined'
import NumbersOutlined from '@mui/icons-material/NumbersOutlined'
import ShortTextOutlined from '@mui/icons-material/ShortTextOutlined'
import TableRowsOutlined from '@mui/icons-material/TableRowsOutlined'
import { SxProps } from '@mui/material'
import { FieldTypeName } from '@/types/fields'
import { getFormattedDateTimeString } from './time'

export default function getDataTypeIcon(data_type: FieldTypeName | 'custom') {
  switch (data_type) {
    case 'category':
      return ArrowDropDownCircleOutlined
    case 'text':
      return ShortTextOutlined
    case 'int':
      return NumbersOutlined
    case 'decimal':
      return NumbersOutlined
    case 'date':
      return CalendarTodayOutlined
    case 'time':
      return AccessTimeOutlined
    case 'datetime':
      return EventOutlined
    case 'currency':
      return AttachMoneyOutlined
    case 'organization':
      return CorporateFareOutlined
    case 'cc_num':
      return CreditCardOutlined
    case 'address':
      return LocationOnOutlined
    case 'phone':
      return LocalPhoneOutlined
    case 'grid':
      return TableRowsOutlined
    case 'checkbox':
      return CheckBoxOutlined
    case 'picker':
    case 'live-list-picker':
      return ExpandCircleDownOutlined
    case 'bar_chart':
      return BarChart
    default:
      return ShortTextOutlined
  }
}

export function getCheckboxFormattedValue(
  value: string,
  sxProps?: SxProps,
  onlyOCR = false,
) {
  if (value === 'TrueBox' || (!onlyOCR && value === 'True')) {
    return <CheckBoxOutlined fontSize="small" sx={sxProps} />
  }

  if (value === 'FalseBox' || (!onlyOCR && value === 'False')) {
    return <CheckBoxOutlineBlankOutlined fontSize="small" sx={sxProps} />
  }
  return value
}

export function getFormattedValue(
  value: string | null,
  fieldCode: FieldTypeName,
) {
  if (!value) return null

  switch (fieldCode) {
    case 'date':
    case 'time':
    case 'datetime':
      return getFormattedDateTimeString(value, fieldCode)
    case 'checkbox':
      return getCheckboxFormattedValue(value)
    default:
      return value
  }
}
